import {
  CreatePronunciationAssignmentRequestDtoAccent,
  CreatePronunciationAssignmentRequestDtoContentLanguage,
} from "@packages/api/madlenAPI.schemas";

export interface VoiceConfig {
  voiceId: string;
  voiceSamplePath: string;
  displayName: string;
  language: string;
  languageCode: CreatePronunciationAssignmentRequestDtoContentLanguage;
  accent?: CreatePronunciationAssignmentRequestDtoAccent;
}

// Import voice sample files
import jamesSample from "@packages/assets/voiceSample/elevenlabs_lUTamkMw7gOzZbFIwmq4.mp3";
import alexisSample from "@packages/assets/voiceSample/elevenlabs_O4fnkotIypvedJqBp4yb.mp3";
import elizabethSample from "@packages/assets/voiceSample/elevenlabs_AXdMgz6evoL7OPd7eU12.mp3";
import owenSample from "@packages/assets/voiceSample/elevenlabs_giAoKpl5weRTCJK7uB9b.mp3";
import billSample from "@packages/assets/voiceSample/elevenlabs_iiidtqDt9FBdT1vfBluA.mp3";
import markSample from "@packages/assets/voiceSample/elevenlabs_UgBBYS2sOqTuMpoF3BR0.mp3";
import hopeSample from "@packages/assets/voiceSample/elevenlabs_OYTbf65OHHFELVut7v2H.mp3";
import hapeSample from "@packages/assets/voiceSample/elevenlabs_uYXf8XasLslADfZ2MB4u.mp3";
import simonSample from "@packages/assets/voiceSample/elevenlabs_K5ZVtkkBnuPY6YqXs70E.mp3";
import christanSample from "@packages/assets/voiceSample/elevenlabs_z1EhmmPwF0ENGYE8dBE6.mp3";
import leaSample from "@packages/assets/voiceSample/elevenlabs_7eVMgwCnXydb3CikjV7a.mp3";
import leonieSample from "@packages/assets/voiceSample/elevenlabs_uvysWDLbKpA4XvpD3GI6.mp3";

export const elevenLabsVoices: VoiceConfig[] = [
  {
    voiceId: "elevenlabs_lUTamkMw7gOzZbFIwmq4",
    voiceSamplePath: jamesSample,
    displayName: "James",
    language: "en_gb",
    languageCode: "en",
    accent: "BRITISH",
  },
  {
    voiceId: "elevenlabs_O4fnkotIypvedJqBp4yb",
    voiceSamplePath: alexisSample,
    displayName: "Alexis",
    language: "en_gb",
    languageCode: "en",
    accent: "BRITISH",
  },
  {
    voiceId: "elevenlabs_AXdMgz6evoL7OPd7eU12",
    voiceSamplePath: elizabethSample,
    displayName: "Elizabeth",
    language: "en_gb",
    languageCode: "en",
    accent: "BRITISH",
  },
  {
    voiceId: "elevenlabs_giAoKpl5weRTCJK7uB9b",
    voiceSamplePath: owenSample,
    displayName: "Owen",
    language: "en_gb",
    languageCode: "en",
    accent: "BRITISH",
  },
  {
    voiceId: "elevenlabs_iiidtqDt9FBdT1vfBluA",
    voiceSamplePath: billSample,
    displayName: "Bill",
    language: "en_us",
    languageCode: "en",
    accent: "AMERICAN",
  },
  {
    voiceId: "elevenlabs_UgBBYS2sOqTuMpoF3BR0",
    voiceSamplePath: markSample,
    displayName: "Mark",
    language: "en_us",
    languageCode: "en",
    accent: "AMERICAN",
  },
  {
    voiceId: "elevenlabs_OYTbf65OHHFELVut7v2H",
    voiceSamplePath: hopeSample,
    displayName: "Hope",
    language: "en_us",
    languageCode: "en",
    accent: "AMERICAN",
  },
  {
    voiceId: "elevenlabs_uYXf8XasLslADfZ2MB4u",
    voiceSamplePath: hapeSample,
    displayName: "Hape",
    language: "en_us",
    languageCode: "en",
    accent: "AMERICAN",
  },
  {
    voiceId: "elevenlabs_K5ZVtkkBnuPY6YqXs70E",
    voiceSamplePath: simonSample,
    displayName: "Simon",
    language: "de_de",
    languageCode: "de",
  },
  {
    voiceId: "elevenlabs_z1EhmmPwF0ENGYE8dBE6",
    voiceSamplePath: christanSample,
    displayName: "Christan",
    language: "de_de",
    languageCode: "de",
  },
  {
    voiceId: "elevenlabs_7eVMgwCnXydb3CikjV7a",
    voiceSamplePath: leaSample,
    displayName: "Lea",
    language: "de_de",
    languageCode: "de",
  },
  {
    voiceId: "elevenlabs_uvysWDLbKpA4XvpD3GI6",
    voiceSamplePath: leonieSample,
    displayName: "Leonie",
    language: "de_de",
    languageCode: "de",
  },
];

// Helper functions for working with voices
export const getVoicesByLanguage = (language: string): VoiceConfig[] => {
  return elevenLabsVoices.filter((voice) => voice.language === language);
};

export const getVoiceById = (voiceId: string): VoiceConfig | undefined => {
  return elevenLabsVoices.find((voice) => voice.voiceId === voiceId);
};

export const getVoiceByDisplayName = (
  displayName: string,
): VoiceConfig | undefined => {
  return elevenLabsVoices.find((voice) => voice.displayName === displayName);
};

// Available languages
export const availableLanguages = ["en_gb", "en_us", "de_de"];

// Voice counts by language
export const voiceCounts = {
  en_gb: elevenLabsVoices.filter((voice) => voice.language === "en_gb").length,
  en_us: elevenLabsVoices.filter((voice) => voice.language === "en_us").length,
  de_de: elevenLabsVoices.filter((voice) => voice.language === "de_de").length,
};
